<gk-map
  class="d-flex flex-column flex-grow-1"
  [mapState]="gkKendoGridMapService.$mapState | async"
  (dispatch)="gkKendoGridMapService.$pendingMapActions.next([$event])"
></gk-map>
